import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AbasteceRua.css";
import { BASE_URL_EXT } from "../../../components/CONSTANTS/BaseURL";

export default function AbasteceRua() {
  const [veiculo, setVeiculo] = useState("");
  const [veiculoBusca, setVeiculoBusca] = useState("");
  const [motorista, setMotorista] = useState("");
  const [produto, setProduto] = useState("");
  const [quantidade, setQuantidade] = useState("");
  const [km, setKm] = useState("");

  const [todosVeiculos, setTodosVeiculos] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    async function carregarVeiculos() {
      try {

        const hoje = new Date()
          .toISOString()
          .split("T")[0];

        const dataLogin =
          localStorage.getItem("login_data");

        if (dataLogin !== hoje) {
          localStorage.removeItem("id_vendedor");
          localStorage.removeItem("login_data");

          window.location.href = "/logrua";
          return;
        }

        // Veículos
        const resVeiculos = await axios.get(
          "https://app.eliandroalimentos.com.br/api/primeiro_acesso/retornaveiculos"
        );

        setTodosVeiculos(resVeiculos.data || []);

        const idVendedor = Number(
          localStorage.getItem("id_vendedor")
        );

        if (!idVendedor) return;

        // Movimentos em aberto
        const resMovimentos = await axios.get(
          "https://app.eliandroalimentos.com.br/api/primeiro_acesso/retornaveiculosnarua"
        );
        //console.log("movimentos",resMovimentos)
        const movimentoMotorista =
          resMovimentos.data.movimentos?.find(
            (m) =>
              Number(m.id_motorista) === idVendedor &&
              (!m.data_retorno || !m.hr_retorno)
          );

        if (movimentoMotorista) {
          const veiculoCompleto = (resVeiculos.data || []).find(
            (v) =>
              String(v.placa).toUpperCase() ===
              String(movimentoMotorista.placa).toUpperCase()
          );

          setVeiculo(movimentoMotorista.placa || "");

          if (veiculoCompleto) {
            setVeiculoBusca(
              `${veiculoCompleto.placa}${veiculoCompleto.tipo || veiculoCompleto.modelo
                ? ` - ${veiculoCompleto.tipo ?? ""}${veiculoCompleto.tipo && veiculoCompleto.modelo
                  ? " / "
                  : ""
                }${veiculoCompleto.modelo ?? ""}`
                : ""
              }`
            );
          } else {
            setVeiculoBusca(movimentoMotorista.placa || "");
          }

          setMotorista(movimentoMotorista.motorista || "");
        }
      } catch (err) {
        console.error(err);
      }
    }

    carregarVeiculos();
  }, []);

  // Fecha modal ao clicar fora
  useEffect(() => {
    function handleClickOutside(e) {
      if (!e.target.closest(".abast-field")) {
        setShowModal(false);
      }
    }

    document.addEventListener("click", handleClickOutside);

    return () =>
      document.removeEventListener(
        "click",
        handleClickOutside
      );
  }, []);

  // Busca local de veículos
  function buscarVeiculos(valor) {
    const filtrados = todosVeiculos.filter((v) =>
      String(v.placa || "")
        .toUpperCase()
        .includes(valor.toUpperCase())
    );

    setVeiculos(filtrados);
    setShowModal(true);
  }

  async function registrarAbastecimento() {
    setMsg("");

    if (!veiculo) {
      setMsg("⚠ Selecione um veículo.");
      return;
    }

    if (!km) {
      setMsg("⚠ Informe o KM do veículo.");
      return;
    }

    if (!motorista.trim()) {
      setMsg("⚠ Informe o motorista.");
      return;
    }

    if (!produto) {
      setMsg("⚠ Selecione o combustível.");
      return;
    }

    if (!quantidade) {
      setMsg("⚠ Informe a quantidade abastecida.");
      return;
    }

    const idMotoristaFinal =
      localStorage.getItem("id_vendedor")
        ? Number(localStorage.getItem("id_vendedor"))
        : undefined;

    console.log("ID_Motorista", idMotoristaFinal)

    function normalizarQuantidade(valor) {
      return Number(
        parseFloat(
          String(valor).replace(",", ".")
        ).toFixed(2)
      );
    }

    const body = {
      veiculo: veiculo.trim().toUpperCase(),
      motorista: motorista.trim(),
      produto,
      quantidade: normalizarQuantidade(quantidade),
      km: Number(km),
      ...(idMotoristaFinal !== undefined && {
        id_motorista: idMotoristaFinal,
      }),
    };

    try {
      setLoading(true);

      await axios.post(
        `https://app.eliandroalimentos.com.br/api/primeiro_acesso/cadastrarabastecimento`,
        body
      );

      setMsg("✅ Abastecimento registrado!");

      setProduto("");
      setQuantidade("");
      setKm("");
      setVeiculo("");
      setVeiculoBusca("");
      setMotorista("");
    } catch (err) {
      console.error(err);

      if (err.response?.data?.error) {
        setMsg(`❌ ${err.response.data.error}`);
      } else if (err.message) {
        setMsg(`❌ ${err.message}`);
      } else {
        setMsg(
          "❌ Erro ao registrar abastecimento"
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="abast-container">
      <div className="abast-wrapper">
        <h2>Abastecimento</h2>

        <div className="abast-card">
          {/* VEÍCULO */}
          <div className="abast-field">
            <label>Veículo (Placa) *</label>

            <input
              type="text"
              value={veiculoBusca}
              inputMode="text"
              autoComplete="off"
              onChange={(e) => {
                const valor =
                  e.target.value.toUpperCase();

                setVeiculoBusca(valor);
                setVeiculo("");

                if (valor.length >= 2) {
                  buscarVeiculos(valor);
                } else {
                  setShowModal(false);
                }
              }}
              placeholder="ABC1234"
            />

            {showModal && (
              <div className="abast-modal">
                {veiculos.length > 0 ? (
                  veiculos.map((v, index) => (
                    <div
                      key={
                        v.id ??
                        v.placa ??
                        index
                      }
                      className="abast-modal-item"
                      onClick={() => {
                        setVeiculo(v.placa);

                        setVeiculoBusca(
                          `${v.placa}${v.tipo || v.modelo
                            ? ` - ${v.tipo ?? ""}${v.tipo && v.modelo ? " / " : ""}${v.modelo ?? ""}`
                            : ""
                          }`
                        );

                        setShowModal(false);
                      }}
                    >
                      <strong>{v.placa}</strong>

                      {(v.tipo || v.modelo) && (
                        <>
                          {" "}
                          - {v.tipo}/{v.modelo}
                        </>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="abast-modal-item">
                    Nenhum veículo encontrado
                  </div>
                )}
              </div>
            )}
          </div>

          {/* KM */}
          <div className="abast-field">
            <label>KM do Veículo *</label>

            <input
              type="number"
              inputMode="numeric"
              value={km}
              onChange={(e) =>
                setKm(e.target.value)
              }
              placeholder="Ex: 120000"
            />
          </div>

          {/* MOTORISTA */}
          <div className="abast-field">
            <label>Motorista *</label>

            <input
              type="text"
              value={motorista}
              autoComplete="off"
              onChange={(e) =>
                setMotorista(
                  e.target.value.toUpperCase()
                )
              }
              placeholder="Nome do motorista"
            />
          </div>

          {/* PRODUTO */}
          <div className="abast-field">
            <label>Combustível *</label>

            <select
              value={produto}
              onChange={(e) =>
                setProduto(e.target.value)
              }
            >
              <option value="">
                Selecione...
              </option>

              <option value="Gasolina Comum">
                Gasolina Comum
              </option>

              <option value="Gasolina Aditivada">
                Gasolina Aditivada
              </option>

              <option value="Diesel S500">
                Diesel S500
              </option>

              <option value="Diesel S10">
                Diesel S10
              </option>

              <option value="Arla">
                Arla
              </option>
            </select>
          </div>

          {/* QUANTIDADE */}
          <div className="abast-field">
            <label>
              Quantidade (Litros) *
            </label>

            <input
              type="number"
              inputMode="numeric"
              value={quantidade}
              onChange={(e) =>
                setQuantidade(
                  e.target.value
                )
              }
              placeholder="Ex: 50.10"
            />
          </div>

          {/* MENSAGEM */}
          {msg && (
            <div className="abast-msg">
              {msg}
            </div>
          )}

          {/* BOTÃO */}
          <button
            className="abast-btn"
            onClick={registrarAbastecimento}
            disabled={loading}
          >
            {loading
              ? "Registrando..."
              : "Abastecer"}
          </button>
        </div>
      </div>
    </div>
  );
}